import { useObserver } from "mobx-react-lite";
import { Fragment } from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";


function Personal() {
  const navigate = useNavigate();
  const personalBack = ()=> {
    try {
      navigate(-1);
    } catch (error) {
      console.log(error);
    }
  }
  return useObserver(() => (
    <Fragment>
      <Button type="primary" onClick={()=>personalBack()}>返回</Button>
      个人中心
    </Fragment>
  ));
}

export default Personal;
